export class Expression {
    static en: any = {
        // code
        tryAgain: 'Please try to reset your password again.',
        invalidCode: 'Code is invalid',
        emailVerified: 'Your email has been verified',
        emailAlreadyVerified: 'Your email is either already verified or the code may be expired.',
        emailCodeExpired: 'The code is either invalid or has expired',
        passwordReuired: 'Please provide your password.',
        passwordLength: 'Your password cannot be less than 8 characters.',
        passwordUpdated: 'Your password has been updated.',
        passwordResetInvalidCode: 'The code has either expired or has already been used',
        passwordNoWhitespace: 'Password must not contain whitespaces.',
        passwordWithUppercase: 'Password must have at least one uppercase character.',
        passwordWithLowercase: 'Password must have at least one lowercase character.',
        passwordWithDigit: 'Password must contain at least one digit.',

        // html
        passwordResetTitle: 'Reset password',
        passwordResetDescription: "Choose a new, strong password that you haven't used before. Make sure it's at least 8 characters long and contains a mix of letters, numbers, and symbols.",
        password: 'Password',
        emailVerificationTitle: 'Email verification',
        continue: 'Continue to app'
    };
    static fr: any = {
        // code
        tryAgain: 'Veuillez réessayer de réinitialiser votre mot de passe.',
        invalidCode: 'Le code n\'est pas valide',
        emailVerified: 'Votre email a été vérifié avec succès',
        emailAlreadyVerified: 'Votre e-mail est déjà vérifié, ou le code est peut-être expiré.',
        emailCodeExpired: 'Le code n\'est pas valide ou a expiré',
        passwordReuired: 'Veuillez fournir un nouveau mot de passe.',
        passwordLength: 'Your password cannot be less than 8 characters.',
        passwordUpdated: 'Votre mot de passe a été mis à jour.',
        passwordResetInvalidCode: 'Le code a expiré ou a déjà été utilisé.',
        passwordNoWhitespace: 'Le mot de passe ne doit pas contenir d\'espaces.',
        passwordWithUppercase: 'Le mot de passe doit contenir au moins un caractère majuscule.',
        passwordWithLowercase: 'Le mot de passe doit contenir au moins un caractère minuscule.',
        passwordWithDigit: 'Le mot de passe doit contenir au moins un chiffre.',

        // html
        passwordResetTitle: 'Réinitialiser votre mot de passe',
        passwordResetDescription: "Choisissez un nouveau mot de passe fort que vous n'avez jamais utilisé auparavant. Assurez-vous qu'il comporte au moins 8 caractères et qu'il contient un mélange de lettres, de chiffres et de symboles.",
        password: 'Mot de passe',
        emailVerificationTitle: 'Vérification de votre email',
        continue: 'Continuer vers l\'application'
    }

    static getText(key: string, lang: string): string {
        if (lang == 'fr') {
            return Expression.fr[key] || '';
        }
        return Expression.en[key] || '';
    }
}